import {isIterable, copyGenerator} from 'rlink-data-connector/storage/collections';
import EmbeddedValue from 'rlink-data-connector/storage/EmbeddedValue';

/**
 * Transforms given storagePayload to a reference value by replacing
 * all embedded values using the given transformEmbedded function.
 *
 * @param  {StoragePayload} storagePayload
 * @param  {EmbeddedValue => Reference} transformEmbedded
 * @return {ReferenceValue}
 */
export default function transformToReferenceValue (storagePayload, transformEmbedded) {
  if (storagePayload instanceof EmbeddedValue) {
    return transformEmbedded(storagePayload);
  } else if (isIterable(storagePayload)) {
    let didTransform = false;
    let transformedCopy = copyGenerator(storagePayload,
      function *(constructValue, entries) {
        for (let [key, value] of entries) {
          yield constructValue(key, transformToReferenceValue(value,
            embedded => {
              didTransform = true;
              return transformEmbedded(embedded);
            }
          ));
        }
      }
    );
    return didTransform ? transformedCopy : storagePayload;
  } else {
    // anything else we leave alone
    return storagePayload;
  }
}



// WEBPACK FOOTER //
// ./lib/rlink-data-connector/storage/transformToReferenceValue.js